var styles = {"box":"GroupLink_box_oq2m8_1","box__inner":"GroupLink_box__inner_oq2m8_18","name":"GroupLink_name_oq2m8_27","icon-container":"GroupLink_icon-container_oq2m8_30","arrow":"GroupLink_arrow_oq2m8_50","expanded":"GroupLink_expanded_oq2m8_63"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
